module.exports = __webpack_public_path__ + "static/img/application4.e4deace3.png";